import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useCallback,
} from "react";
import DatePicker from "react-datepicker";
import {
  IntakeSheetSession,
  HippaDeclareConstant,
  RoleType,
} from "../../../Constant";
import {
  GragIntakeSheetData,
} from "../IntakeSheetUtils";
import moment from "moment";
import toast from "react-hot-toast";
import { GetCaseFormListData, SaveCaseFormData } from "../Service";
import SignaturePad from "../../../Component/shared/signaturePad";
import "./HippaDeclaration.css";
import SpinnerLoader from "../../../Component/shared/loader/spinnerLoader/SpinnerLoader";
import { usePatientData } from "../../../commonFunction/storage/Patientdatacontext";


const HippaDeclare = forwardRef(function HippaDeclare(props, ref) {
  const [loading, setLoading] = useState(false);
  const [patientName, setPatientName] = useState("");
  const [DOA, setDOA] = useState(new Date());
  const [SSN, setSSN] = useState("");
  const [patientSignImg, setPatientSignImg] = useState("");
  const [PatientDOS, setPatientDOS] = useState(new Date());
  const [LegalGuardian, setLegalGuardian] = useState("");
  const [providerSignImg, setProviderSignImg] = useState("");
  const [GuardianDOS, setGuardianDOS] = useState(new Date());
  const [collectionOfhippaDeclare, setCollectionOfhippaDeclare] = useState([]);
  const [BeforeParsinghippaAuthDeclare, setBeforeParsinghippaAuthDeclare] = useState([]);
  const [signRole, setSignRole] = useState("");
  const [SearchResult, setSearchResult] = useState([]);
  const [CaseFormDataId, setCaseFormDataId] = useState("");
  const [isCalledFromIntakeSheet, setIsCalledFromIntakeSheet] = useState(false);
  const [PatientData, setPatientData] = useState([]);
  const [isPatientSign, setIsPatientSign] = useState(false);
  const [isGuardianSign, setIsGuardianSign] = useState(false);
  const [isSelectedProvider, setIsSelectedProvider] = useState(false);
  const [caseFormData, setCaseFormData] = useState({});
  const [sigPadOpen, setSigPadOpen] = useState(false);

    const { patientData, fetchPatientData } = usePatientData();

  const stateRef = React.useRef({});
  useEffect(() => {
    stateRef.current = {
      providerSignImg, patientSignImg, LegalGuardian,
      GuardianDOS, PatientDOS, patientName, DOA, SSN,
      collectionOfhippaDeclare, BeforeParsinghippaAuthDeclare,
    };
  });

  const tokenData = JSON.parse(sessionStorage.getItem("tokenData") || {});

  const handleGetCaseFormData = async () => {
    try {
      let requestBody = {
        CaseFormDataId: null,
        CaseId: tokenData.caseId,
        CompanyId: tokenData.companyId,
        DoctorId: "ALL",
        EntityLevel: 0,
        FormId: 3,
        FormName: "HIPPA Declaration",
        FormType: null,
        IsFormCompleted: false,
        JsonData: null,
        TemplateName: null,
        UserId: tokenData?.userId,
      };
      const response = await GetCaseFormListData(requestBody);
      if (response?.HasException) {
        toast.error(`Something went wrong. ${response?.MessageText}. ${response?.Exception}`);
      } else {
        let data = response?.Data[0] || {};
        setCaseFormData(data);
        return data;
      }
    } catch (error) {
      toast.error(error.message);
      return {};
    }
  };

  const CallSaveApiForIntakeSheet = async (jsonData) => {
    try {
      setLoading(true);
      const payload = {
        CaseFormDataId: 48236,
        CaseId: tokenData?.caseId,
        CompanyId: tokenData?.companyId,
        DoctorId: tokenData?.doctorId,
        EntityLevel: 0,
        FormId: 3,
        FormName: "HIPPA Declaration",
        FormType: null,
        IsChanged: false,
        IsCopySign: false,
        IsFormCompleted: false,
        TemplateName: null,
        UserId: tokenData?.userId,
        officeId: tokenData?.providerId,
        JsonData: jsonData,
      };
      const response = await SaveCaseFormData(payload);
      if (response.HasException) {
        toast.error("Error while saving Hippa Declaration.");
        return false;
      } else {
        toast.success("Hippa Declaration saved successfully.");
        return true;
      }
    } catch {
      toast.error("Error while saving Hippa Declaration.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  const clickPatientSign = () => {
    setSearchResult({});
    setIsPatientSign(true);
    setIsGuardianSign(false);
    setSigPadOpen(true);
    setSignRole(RoleType.Patient);
    setIsCalledFromIntakeSheet(true);
  };

  const clickSignatureLegalGuardian = () => {
    setSearchResult({});
    setIsGuardianSign(true);
    setIsPatientSign(false);
    setSigPadOpen(true);
    setSignRole(RoleType.Other);
    setIsCalledFromIntakeSheet(true);
  };


  const SignUpdatedCall = (base64Img) => {
    const newBaseString = base64Img.includes(IntakeSheetSession.dataBlock1)
      ? base64Img.replace(IntakeSheetSession.dataBlock1, IntakeSheetSession.dataBlock)
      : base64Img;
    if (isGuardianSign) { setProviderSignImg(newBaseString); setGuardianDOS(new Date()); }
    if (isPatientSign) {
      setPatientSignImg(newBaseString);
      setPatientDOS(new Date());
      sessionStorage.setItem("sharedPatientSignature", newBaseString); // ← ADD
    }
  };

  const ClearSignCall = () => {
    if (isPatientSign) { setPatientSignImg(""); setPatientDOS(""); }
    if (isGuardianSign) { setProviderSignImg(""); setGuardianDOS(""); }
  };

  const buildUpdatedCollection = (collection, vals) => {
    const updated = [...collection];
    const { patientName, DOA, SSN, patientSignImg, PatientDOS,
            LegalGuardian, providerSignImg, GuardianDOS } = vals;

    const set = (key, value) => {
      const idx = updated.findIndex((x) => x.Name === key);
      if (idx !== -1) updated[idx] = { ...updated[idx], Value: value };
    };
    const fmtDate = (d) =>
      d === "" || d == null ? "" : moment(d).format("MM-DD-YYYY").split("-").join("/");

    set(HippaDeclareConstant.PatientName, patientName);
    set(HippaDeclareConstant.AccidentDate, fmtDate(DOA));
    set(HippaDeclareConstant.PatientSSN, SSN);
    set(HippaDeclareConstant.PatientSign, patientSignImg);
    set(HippaDeclareConstant.PatientSignDate, fmtDate(PatientDOS));
    set(HippaDeclareConstant.ProviderName, tokenData.providerName);
    set(HippaDeclareConstant.GuardianName, LegalGuardian);
    set(HippaDeclareConstant.PatientName2, patientName);
    set(HippaDeclareConstant.GuardianSign, providerSignImg);
    set(HippaDeclareConstant.GuardianSignDate, fmtDate(GuardianDOS));
    return updated;
  };

  const saveFunction = async () => {
    setLoading(true);
    const s = stateRef.current;
    const updatedCollection = buildUpdatedCollection(s.collectionOfhippaDeclare, s);
    setCollectionOfhippaDeclare(updatedCollection);
    const result = await FormJsonRequest(updatedCollection);
    setLoading(false);
    return result;
  };

  const buildNotesData = (updatedCollection, parsedData) => {
    try {
      const clone = JSON.parse(JSON.stringify(parsedData));
      for (let i = 0; i < clone.notesdata.length; i++) {
        const filterResult = updatedCollection.filter(
          (x) => x.RenderKeyName === clone.notesdata[i].RenderKeyName,
        );
        if (filterResult.length === 0) continue;
        for (let j = 0; j < clone.notesdata[i].ApplicationValue.length; j++) {
          if (clone.notesdata[i].ApplicationValue[j].Name !== filterResult[j]?.Name) continue;
          clone.notesdata[i].ApplicationValue[j].Type = filterResult[j].Type;
          clone.notesdata[i].ApplicationValue[j].isRender = filterResult[j].isRender;
          const isSign =
            clone.notesdata[i].ApplicationValue[j].Name === HippaDeclareConstant.PatientSign ||
            clone.notesdata[i].ApplicationValue[j].Name === HippaDeclareConstant.GuardianSign;
          if (isSign) {
            const val = filterResult[j].Value;
            if (val) {
              clone.notesdata[i].ApplicationValue[j].Value = val.includes(";")
                ? val.split(";")[1].split(",")[1]
                : val;
            } else {
              clone.notesdata[i].ApplicationValue[j].Value = "";
            }
          } else {
            clone.notesdata[i].ApplicationValue[j].Value = filterResult[j].Value;
          }
        }
      }
      return clone;
    } catch (error) {
      console.error(error.message);
    }
  };

  const FormJsonRequest = async (updatedCollection) => {
    const data = buildNotesData(updatedCollection, stateRef.current.BeforeParsinghippaAuthDeclare);
    const result = await CallSaveApiForIntakeSheet(JSON.stringify(data));
    setCollectionOfhippaDeclare(updatedCollection);
    return result;
  };

  const BindValueToControl = async (collection, patientInfo, patientName) => {
    const getVal = (key) => {
      const found = collection.find((x) => x.Name === key);
      return found ? found.Value : "";
    };
    const normalise = (raw) =>
      !raw ? "" : raw.includes(IntakeSheetSession.dataBlock) ? raw : IntakeSheetSession.dataBlock + raw;
    const parsedDate = (val) => { const d = new Date(val); return isNaN(d.getTime()) ? "" : d; };

    setSSN(patientInfo?.ssn);
    const savedSig = props.copySignature
      ? sessionStorage.getItem("sharedPatientSignature")
      : null;
    setPatientSignImg(savedSig || normalise(getVal(HippaDeclareConstant.PatientSign)));
    setLegalGuardian(getVal(HippaDeclareConstant.GuardianName) || patientName);
    setProviderSignImg(normalise(getVal(HippaDeclareConstant.GuardianSign))); // ← never copy shared sig here
    setGuardianDOS(parsedDate(getVal(HippaDeclareConstant.GuardianSignDate)));
    setIsSelectedProvider(false);
    setLoading(false);
  };

  useEffect(() => { callApi(); }, [patientData]);

  useEffect(() => {
    props?.onReady?.("hipaa_decl");
  }, [patientSignImg]);


  const checkIsPending = () => {
    if (!patientSignImg) return true;
    return false;
  };

  const callApi = useCallback(async () => {
    setLoading(true);
    const formData = await handleGetCaseFormData();
    const patientInfo = patientData || await fetchPatientData(tokenData?.caseId, tokenData?.companyId);
    const patientName = patientInfo?.patientFirstName + " " + patientInfo?.patientLastName;
    setPatientName(patientName);
    const HippaDeclareData = JSON.parse(formData?.JsonData);
    const collection = GragIntakeSheetData(HippaDeclareData);
    setCollectionOfhippaDeclare(collection);
    setBeforeParsinghippaAuthDeclare(HippaDeclareData);
    setCaseFormDataId(formData.CaseFormDataId);
    await BindValueToControl(collection, patientInfo, patientName);
    setLoading(false);
  }, [patientData]);

  useImperativeHandle(ref, () => ({
    save: () => saveFunction(true),
    isPending: () => checkIsPending(),
    getSignature:   () => patientSignImg || "",
    applySignature: (sig) => {
      if (!sig) return;
      setPatientSignImg(sig);
      setPatientDOS(new Date());
    }
  }), [patientSignImg, providerSignImg]);

  const proLabel = tokenData.providerName || "";

  return (
    <>
      {loading ? (
        <SpinnerLoader message="Loading form data…" />
      ) : (
        <div className="hd__wrapper">

          {/* ── Title ── */}
          <div className="hd__title-block">
            <div className="hd__title-main">HIPAA Declaration</div>
          </div>

          {/* ── "I, [name], declare as follows" ── */}
          <div className="hd__sentence-row">
            <span className="hd__sentence-word">I,</span>
            <div className="hd__sentence-field">
              <input
                className="hd__input"
                type="text"
                value={patientName}
                disabled
              />
            </div>
            <span className="hd__sentence-word">, declare as follows</span>
          </div>

          {/* ── Declaration paragraphs ── */}
          <div className="hd__legal-panel">
            That at the time of the accident occurring on . I was driver / passenger / pedestrian /
            present in the vehicle involved, and I sustained injuries as a result of said accident.
          </div>

          <div className="hd__legal-panel">
            I hereby certify that I have sought your treatment and / or service on my own and that no
            one solicited my coming for treatment or promised me any remuneration or benefit for coming
            for treatment. I further declare that prior to the accident I had no knowledge of the driver
            of the other vehicle involved and to the best of my knowledge said accident was not staged.
            I have been advised that bringing a fraudulent claim is a crime punishable by imprisonment
            fine, and / or both.
          </div>

          {/* ── Patient Info ── */}
          <div className="hd__section">
            <span className="hd__section-title">Patient Information</span>
            <span className="hd__section-line" />
          </div>

          <div className="hd__grid-row">
            <span className="hd__grid-label"><b>Name :</b></span>
            <div>
              <input
                className="hd__input"
                type="text"
                value={patientName}
                onChange={(e) => setPatientName(e.target.value)}
                disabled
              />
            </div>
            <span className="hd__grid-label"><b>Date Of Accident:</b></span>
            <div>
              <DatePicker
                selected={DOA}
                onChange={(e) => setDOA(e)}
                dateFormat="MM/dd/yyyy"
                className="hd__datepicker hd__datepicker--full"
                showYearDropdown showMonthDropdown dropdownMode="select"
                disabled
              />
            </div>
          </div>

          <div className="hd__grid-row">
            <span className="hd__grid-label"><b>SSN:</b></span>
            <div>
              <input
                className="hd__input"
                type="text"
                value={SSN}
                onChange={(e) => setSSN(e.target.value)}
                disabled
              />
            </div>
            <span className="hd__grid-label"><b>Date Of Signature:</b></span>
            <div>
              <DatePicker
                selected={PatientDOS}
                onChange={(e) => setPatientDOS(e)}
                dateFormat="MM/dd/yyyy"
                className="hd__datepicker hd__datepicker--full"
                showYearDropdown showMonthDropdown dropdownMode="select"
              />
            </div>
          </div>

          {/* ── Patient Signature ── */}
          <div className="hd__section">
            <span className="hd__section-title">Signature</span>
            <span className="hd__section-line" />
          </div>

          <div className="hd__grid-row hd__grid-row--2col">
            <span className="hd__sign-label">Signature :</span>
            <div
              className={`hd__sign-box${patientSignImg ? "" : " hd__sign-box--empty"}`}
              onClick={clickPatientSign}
            >
              {patientSignImg && (
                <img src={patientSignImg} className="hd__sign-img" alt="Patient Signature" />
              )}
            </div>
          </div>

          {/* ── Patient HIPAA Awareness ── */}
          <div className="hd__section">
            <span className="hd__section-title">Patient HIPAA Awareness</span>
            <span className="hd__section-line" />
          </div>

          {/* Provider Name */}
          <div className="hd__provider-row">
            <span className="hd__provider-label"><b>Provider Name:</b></span>
            <input className="hd__input" type="text" value={tokenData.providerName} disabled />
          </div>

          {/* Awareness paragraphs */}
          <div className="hd__legal-panel">
            With my awareness, <b>{proLabel}</b> may use and disclose protected health information (PHI)
            about me to carry out treatment, payment, and healthcare operations (TPO). Please refer to{" "}
            <b>{proLabel}</b>'s Notice of Privacy Practices for a more complete description of such uses
            and disclosures.
          </div>

          <div className="hd__legal-panel">
            I have the right to review the Notice of Privacy Practices prior to signing this consent.{" "}
            <b>{proLabel}</b> reserves the right to revise its Notice of Privacy Practices at any time.
            A revised Notice of Privacy Practices may be obtained by forwarding a written request to the
            Privacy Officer.
          </div>

          <div className="hd__legal-panel">
            With my permission, the office of <b>{proLabel}</b> may call my home or other designated
            location and leave a message on voice mail or in person in reference to any items that assist
            the practice in carrying out TPO, such as appointment reminders, insurance items and any call
            pertaining to my clinical care, including laboratory results among others.
          </div>

          <div className="hd__legal-panel">
            With my permission, the office of <b>{proLabel}</b> may mail to my home or other designated
            location any items that assist the practice in carrying out TPO, such as appointment reminder
            cards and patient statements as long as they are marked Personal and Confidential.
          </div>

          <div className="hd__legal-panel">
            With my permission, the office of <b>{proLabel}</b> may e-mail to my home or other designated
            location any items that assist the practice in carrying out TPO such as appointment reminder
            cards and patient statements. I have the right to request that <b>{proLabel}</b> restricts how
            it uses or discloses my PHI to carry out TPO. However, the practice is not required to agree
            to my requested restrictions, but if it does, it is bound by this agreement.
          </div>

          <div className="hd__legal-panel">
            By signing this, I am allowing <b>{proLabel}</b> to use and disclose my PHI for TPO.
          </div>

          <div className="hd__legal-panel">
            I may revoke my consent in writing except to the extent that the practice has already made
            disclosure in reliance upon my prior consent.
          </div>

          {/* ── Guardian Section ── */}
          <div className="hd__section">
            <span className="hd__section-title">Patient or Legal Guardian</span>
            <span className="hd__section-line" />
          </div>

          <div className="hd__guardian-row">
            <span className="hd__grid-label"><b>Name of Patient or Legal Guardian:</b></span>
            <input
              className="hd__input"
              type="text"
              value={LegalGuardian}
              onChange={(e) => setLegalGuardian(e.target.value)}
            />
          </div>

          <div className="hd__grid-row hd__grid-row--2col" style={{ marginBottom: 14 }}>
            <span className="hd__sign-label">Signature of Patient or Legal Guardian:</span>
            <div
              className={`hd__sign-box${providerSignImg ? "" : " hd__sign-box--empty"}`}
              onClick={clickSignatureLegalGuardian}
            >
              {providerSignImg && (
                <img src={providerSignImg} className="hd__sign-img" alt="Guardian Signature" />
              )}
            </div>
          </div>

          <div className="hd__grid-row hd__grid-row--2col">
            <span className="hd__grid-label"><b>Date Of Signature:</b></span>
            <DatePicker
              selected={GuardianDOS}
              onChange={(e) => setGuardianDOS(e)}
              dateFormat="MM/dd/yyyy"
              className="hd__datepicker"
              showYearDropdown showMonthDropdown dropdownMode="select"
            />
          </div>

          {/* ── Signature Pad ── */}
          {sigPadOpen && (
            <SignaturePad
              isOpen={sigPadOpen}
              title={signRole === RoleType.Patient ? "Patient Signature" : "Guardian Signature"}
              existingSign={signRole === RoleType.Patient ? patientSignImg : providerSignImg}
              onClose={() => setSigPadOpen(false)}
              onSave={(base64) => { SignUpdatedCall(base64); setSigPadOpen(false); }}
              onClear={ClearSignCall}
            />
          )}
        </div>
      )}
    </>
  );
});

export default HippaDeclare;